import { createSlice } from "@reduxjs/toolkit";

const collectionSlice = createSlice({
  name: "collection",
  initialState: {
    collectionArray: [], // Store API response here
  },
  reducers: {
    setcollection(state, action) {
      state.collectionArray = action.payload; // Update state correctly
    },
  },
});

export const { setcollection } = collectionSlice.actions;
export default collectionSlice.reducer;
